// extracted by mini-css-extract-plugin
module.exports = {"applyFilter":"TasksFilter_applyFilter__3d89b","filterLayoutTitle":"TasksFilter_filterLayoutTitle__o46IC","statusDropdownContainer":"TasksFilter_statusDropdownContainer__3bOJB"};